/*
  for some reason, the only way to get the add to quote button to work when there are options is to have the theme's cart setting set to Popup Notification
  however when this is enabled the button stops working for products that have no options....

  so to force it to work i am just going to manually call the shopify ajax api and redirect if there are no options
*/

(function(){
  async function addProductHack(form) {
    const formData = new FormData(form);
    const resp = await fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'post',
      body: formData,
    });

    const json = await resp.json();

    console.log(json);

    document.location = '/cart';
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded', window.jQuery)
    $('#sm-submit-cart-btn').on('click', function(e){
      if (!$(this).hasClass('po-atc-btn')) {
        addProductHack(this.form);
        e.preventDefault();
        return false;
      }
    });
  });
})();
